const location =
  (typeof window !== "undefined" && window.location.hostname) || "";
let keyRedirectionStripe = "ca_EoKD7yQIJOPERD87tSQOMwqNfRvWVXbB";
let urlRedirectionStripe = "http://localhost:3003/admin#/stripe";
let urlIntegrate = "http://localhost:3001/commande-en-ligne/";
let keyPublicStripe = "pk_test_Lbvq8ip5OMFDkKLFnJLLsdsl00M1qwWBEi";
let logAuth = "http://localhost:3000/logout";
let urlAuth = "http://localhost:3000/";
let urlEspaceClient = "http://localhost:3300/";
let mediation = "http://localhost:5000/partners/CommandeEnLigne";

if (location === "commande-en-ligne.laddit.io") {
  urlRedirectionStripe = "https://commande-en-ligne.laddit.io/admin#/stripe";
  urlIntegrate = "https://commande-en-ligne.laddit.io/commande-en-ligne/";
  logAuth = "https://auth.laddit.io/logout";
  urlAuth = "https://auth.laddit.io/";
  urlEspaceClient = "https://espace-client.laddit.io/";
  mediation = "https://mediation-client.laddit.io/partners/celladdition";
} else if (location === "commande-en-ligne.laddition.com") {
  keyRedirectionStripe = "ca_EoKDHN4IMya5ZPHTR2OuosDdjInzUPcf";
  urlRedirectionStripe =
    "https://commande-en-ligne.laddition.com/admin#/stripe";
  urlIntegrate = "https://commande-en-ligne.laddition.com/commande-en-ligne/";
  keyPublicStripe = "pk_live_fQNMaz4j2H07NsqeA179ZajT00f0XVVZ4o";
  logAuth = "https://auth.laddition.com/logout";
  urlAuth = "https://auth.laddition.com/";
  urlEspaceClient = "https://espace-client.laddition.com/";
  mediation = "https://mediation-client.laddition.com/partners/celladdition";
}

const LOGROCKET_PROJECT = "q2xmea/commande-en-ligne";
const serviceName =  "click_collect";

export default {
  urlRedirectionStripe,
  keyRedirectionStripe,
  urlIntegrate,
  keyPublicStripe,
  logAuth,
  urlAuth,
  urlEspaceClient,
  mediation,
  LOGROCKET_PROJECT,
  serviceName
};
